import React from "react";
import { Button } from "../ui/button";
import { BellRing, Briefcase, Building2, CheckCircle2 } from "lucide-react";

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** Aviso rápido no topo do painel admin com o que está à espera de moderação. */
export const PendingAlert = ({ pendingJobs = 0, pendingCompanies = 0, onGoJobs, onGoCompanies }) => {
  const total = (pendingJobs || 0) + (pendingCompanies || 0);

  if (!total) {
    return (
      <div
        data-testid="admin-pending-alert-empty"
        className="mb-8 flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4"
      >
        <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" />
        <p className="text-sm text-emerald-900">
          <span className="font-semibold">Nada à espera de moderação.</span>{" "}
          Todas as vagas e empresas registadas já foram tratadas.
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid="admin-pending-alert"
      className="mb-8 rounded-2xl border border-amber-300 bg-amber-50 px-5 py-4 flex flex-wrap items-center justify-between gap-4"
    >
      <div className="flex items-start gap-3">
        <span className="relative mt-0.5 shrink-0">
          <BellRing className="w-5 h-5 text-amber-600" />
          <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
        </span>
        <div>
          <p data-testid="admin-pending-alert-text" className="text-sm font-semibold text-amber-900">
            {pendingCompanies > 0 && plural(pendingCompanies, "empresa", "empresas")}
            {pendingCompanies > 0 && pendingJobs > 0 && " e "}
            {pendingJobs > 0 && plural(pendingJobs, "vaga", "vagas")}
            {" "}à espera de aprovação
          </p>
          <p className="text-xs text-amber-800/80 mt-0.5">
            Aprova ou rejeita para que fiquem visíveis no site.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {pendingCompanies > 0 && (
          <Button
            data-testid="admin-pending-goto-companies"
            size="sm"
            variant="outline"
            className="rounded-full border-amber-400 bg-white text-amber-800 hover:bg-amber-100"
            onClick={onGoCompanies}
          >
            <Building2 className="w-4 h-4 mr-1.5" />
            Ver empresas ({pendingCompanies})
          </Button>
        )}
        {pendingJobs > 0 && (
          <Button
            data-testid="admin-pending-goto-jobs"
            size="sm"
            className="rounded-full bg-amber-600 hover:bg-amber-700"
            onClick={onGoJobs}
          >
            <Briefcase className="w-4 h-4 mr-1.5" />
            Ver vagas ({pendingJobs})
          </Button>
        )}
      </div>
    </div>
  );
};

export default PendingAlert;
